//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum BulkOperationStatus {
	Pending = 1,
	Running = 2,
	Completed = 3,
	Failed = 4
}
